import { getSsrState } from 'src/utils/ssr.js';
import { createVueApp } from 'src/utils/vue.js';

import CompanySidebarContextMenu from 'src/components/companies/CompanySidebarContextMenu/CompanySidebarContextMenu.vue';

const el = document.querySelector('[data-company-context-menu]');
const { hasBrandedProfile, companyAlias, adminLinks } = getSsrState();

if (el) {
  const app = createVueApp({
    render(h) {
      return h(CompanySidebarContextMenu, {
        props: {
          hasBrandedProfile,
          companyAlias,
          adminLinks,
        },
      });
    },
  });

  app.$mount(el);
}
